import React from 'react'
import { Col, Row } from 'antd'
import { FormikProps } from 'formik'
import { useTranslation } from 'react-i18next'

import { DatePicker, Input } from 'src/components/Formik'
import { Title } from 'src/components/Ant'

import { InitialValues } from '../initial-values'

interface Props {
  formikProps: FormikProps<InitialValues>
}

export default function UserVehicleInfo({ formikProps }: Props) {
  const { t } = useTranslation()
  return (
    <>
      <Title level={4}>{t('web.user.common.mandatory_for_car_rental')}</Title>
      <Row gutter={24}>
        <Col span={8}>
          <Input
            formikProps={formikProps}
            label="web.user.common.driver_license_number.title"
            name="driver_license_number"
            required={false}
          />
        </Col>
        <Col span={8}>
          <DatePicker
            formikProps={formikProps}
            label="web.user.common.expiration.title"
            name="driver_license_expires_on"
            required={false}
          />
        </Col>
      </Row>
    </>
  )
}
